// extracted by mini-css-extract-plugin
export default {"container":"Card_container__o-p0M","establishmentName":"Card_establishmentName__mm-y3","buttonArea":"Card_buttonArea__P8-oU","thumbnailsArea":"Card_thumbnailsArea__HrtHV"};